// @ts-nocheck
import { Plugin } from 'E:/zkh/word/PC_word/A9_Umi_WDC/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
